// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/ProgressTimeline.jsx

import React from 'react';

export default function ProgressTimeline({
  steps = [],
  activeStep = 0,
  highestReachedStep = activeStep,
  stepStatuses = {},
  onStepSelect,
}) {
  return (
    <nav
      className="mission-progress-timeline"
      aria-label="Mission Launch progress"
    >
      {steps.map((step, index) => {
        const isActive = index === activeStep;
        const isReachable = index <= highestReachedStep;
        const persistedStatus = String(
          stepStatuses?.[step.key] || ''
        ).trim().toLowerCase();

        const isComplete =
          persistedStatus === 'complete' ||
          (step.key === 'welcome' && highestReachedStep > 0);

        const state = isActive
          ? 'active'
          : isComplete
            ? 'complete'
            : isReachable
              ? 'available'
              : 'locked';

        const title = !isReachable
          ? `${step.label} unlocks as Mission Launch progresses`
          : isActive
            ? `Current step: ${step.label}`
            : isComplete
              ? `Completed step: ${step.label}`
              : `Available step: ${step.label}`;

        return (
          <button
            type="button"
            className={`mission-progress-step mission-progress-step-${state} mission-progress-step-button`}
            key={step.key || step.label}
            onClick={() => isReachable && onStepSelect?.(index)}
            disabled={!isReachable}
            aria-current={isActive ? 'step' : undefined}
            aria-disabled={!isReachable}
            title={title}
          >
            <span className="mission-progress-index">
              {isComplete ? '✓' : index + 1}
            </span>
            <span className="mission-progress-label">
              {step.label}
            </span>
            {!isReachable ? (
              <span
                className="mission-progress-lock"
                aria-hidden="true"
              >
                Locked
              </span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
